import { ErrorMessages } from "./_errorTypes";

export const errorMessages: ErrorMessages = {
    en: {
        GENERAL_ERROR_MESSAGE: 'An unknown error occurred',
    },
    de: {
        GENERAL_ERROR_MESSAGE: 'Ein unbekannter Fehler ist aufgetreten',
    },
    fr: {
        GENERAL_ERROR_MESSAGE: 'Une erreur inconnue est survenue',
    },
    it: {
        GENERAL_ERROR_MESSAGE: 'Si è verificato un errore sconosciuto',
    }
};